__turbopack_context__.v({
  "errorToast": "ClientProjects-module-scss-module__I3bGbG__errorToast",
  "errorToastMobile": "ClientProjects-module-scss-module__I3bGbG__errorToastMobile",
  "isLess": "ClientProjects-module-scss-module__I3bGbG__isLess",
  "isMore": "ClientProjects-module-scss-module__I3bGbG__isMore",
  "projects": "ClientProjects-module-scss-module__I3bGbG__projects",
  "projectsContainer": "ClientProjects-module-scss-module__I3bGbG__projectsContainer",
  "projectsMobile": "ClientProjects-module-scss-module__I3bGbG__projectsMobile",
  "showMoreLessButton": "ClientProjects-module-scss-module__I3bGbG__showMoreLessButton",
  "showMoreLessButtonIcon": "ClientProjects-module-scss-module__I3bGbG__showMoreLessButtonIcon",
});
